export const DeviceFingerprint = {
    // Высокоскоростной алгоритм хеширования строк
    hashMurmur3(str) {
        let h1 = 0xdeadbeef, iterator = 0, bits, currentByte;
        const remainder = str.length & 3;
        const loops = str.length - remainder;
        
        while (iterator < loops) {
            bits = ((str.charCodeAt(iterator++) & 0xff)) |
                   ((str.charCodeAt(iterator++) & 0xff) << 8) |
                   ((str.charCodeAt(iterator++) & 0xff) << 16) |
                   ((str.charCodeAt(iterator++) & 0xff) << 24);
            bits = Math.imul(bits, 0xcc9e2d51);
            bits = (bits << 15) | (bits >>> 17);
            bits = Math.imul(bits, 0x1b873593);
            h1 ^= bits;
            h1 = (h1 << 13) | (h1 >>> 19);
            h1 = Math.imul(h1, 5) + 0xe6546b64;
        }
        bits = 0;
        switch (remainder) {
            case 3: bits ^= (str.charCodeAt(iterator + 2) & 0xff) << 16;
            case 2: bits ^= (str.charCodeAt(iterator + 1) & 0xff) << 8;
            case 1: bits ^= (str.charCodeAt(iterator) & 0xff);
                    bits = Math.imul(bits, 0xcc9e2d51);
                    bits = (bits << 15) | (bits >>> 17);
                    bits = Math.imul(bits, 0x1b873593);
                    h1 ^= bits;
        }
        h1 ^= str.length;
        h1 ^= h1 >>> 16;
        h1 = Math.imul(h1, 0x85ebca6b);
        h1 ^= h1 >>> 13;
        h1 = Math.imul(h1, 0xc2b2ae35);
        h1 ^= h1 >>> 16;
        return (h1 >>> 0).toString(16);
    },

    // Получение Canvas-отпечатка (зависит от видеокарты и сглаживания шрифтов ОС)
    getCanvasFingerprint() {
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) return 'no-canvas';
            
            canvas.width = 200;
            canvas.height = 50;
            
            // Рисуем текст с разными шрифтами, смайликами и градиентом
            ctx.textBaseline = "top";
            ctx.font = "14px 'Arial', sans-serif";
            ctx.textBaseline = "alphabetic";
            ctx.fillStyle = "#f60";
            ctx.fillRect(125, 1, 62, 20);
            ctx.fillStyle = "#069";
            ctx.fillText("Fingerprint 1.0 😃", 2, 15);
            ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
            ctx.font = "16px 'MS Gothic', sans-serif";
            ctx.fillText("🔤 С# .NET8 🔤", 4, 45);
            
            return canvas.toDataURL();
        } catch (e) {
            return 'canvas-error';
        }
    },

    formatWebGLShaderPrecisionFormat(e) {
        if (!e) return '[]';
        const array = [
            e.precision,
            e.rangeMin,
            e.rangeMax
        ];
        return `[${array.join('~')}]`;
    },

    // Получение информации о видеокарте
    getWebGlRenderer() {
        try {
            const canvas = document.createElement('canvas');
            const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
            if (!gl) return 'no-webgl';
            
            const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
            if (!debugInfo) return 'no-webgl-debug';
            
            // return gl.getParameter(debugInfo.UNMASKED_RENDERER_VENDOR_String) + '~' + 
            //        gl.getParameter(debugInfo.UNMASKED_RENDERER_DEVICE_String);

            const array = [
                gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || 'unknown-renderer',
                gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) || 'unknown-vendor',
                gl.getParameter(gl.MAX_TEXTURE_SIZE),
                gl.getParameter(gl.MAX_VIEWPORT_DIMS),
                gl.getParameter(gl.MAX_RENDERBUFFER_SIZE),
                gl.getParameter(gl.MAX_VERTEX_ATTRIBS),
                gl.getParameter(gl.MAX_VARYING_VECTORS),
                gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS),
                gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE),
                gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE),

                gl.getParameter(gl.MAX_3D_TEXTURE_SIZE) || 'MAX_3D_TEXTURE_SIZE',
                gl.getParameter(gl.MAX_ARRAY_TEXTURE_LAYERS) || 'MAX_ARRAY_TEXTURE_LAYERS',
                gl.getParameter(gl.MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS) || 'MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS',

                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT)),

                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT)),
                this.formatWebGLShaderPrecisionFormat(gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT)),
            ]

            // console.log(array.join('~'));

            // // ИСПРАВЛЕНИЕ: Константы берутся напрямую из объекта расширения debugInfo
            // // Они должны быть строго в ВЕРХНЕМ РЕГИСТРЕ: UNMASKED_RENDERER_VENDOR_WEBGL и UNMASKED_RENDERER_DEVICE_WEBGL
            // const vendor = gl.getParameter(debugInfo.UNMASKED_RENDERER_VENDOR_WEBGL);
            // const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_DEVICE_WEBGL);
            
            // return (vendor || 'unknown-vendor') + '~' + (renderer || 'unknown-device');

            return array.join('~');
        } catch (e) {
            // Если браузер выбросил ошибку INVALID_ENUM или заблокировал вызов — возвращаем заглушку
            console.warn('WebGL Renderer info protection triggered:', e.message);
            return 'webgl-error';
        }
    },

    // Сборка всех параметров в единую строку и генерация ID
    generateIdSync() {
        const components = [
            navigator.userAgent,
            navigator.language,
            new Date().getTimezoneOffset(),
            Intl.DateTimeFormat().resolvedOptions().timeZone,
            screen.width + 'x' + screen.height + 'x' + screen.colorDepth,
            navigator.hardwareConcurrency || 'unknown',  // Ядра CPU
            navigator.deviceMemory || 'unknown',         // RAM в ГБ
            navigator.maxTouchPoints || 0,               // Тач-скрин
            this.getWebGlRenderer(),                     // Модель видеокарты
            this.getCanvasFingerprint()                  // Canvas-отпечаток
        ];

        // Объединяем все данные в одну строку
        const rawString = components.join('||');
        
        // Возвращаем уникальный хэш устройства
        return this.hashMurmur3(rawString);
    }
};